import React from 'react';
import { Tabs } from 'antd';
import { useLocation } from 'react-router-dom';
import { TruckOutlined, AuditOutlined } from '@ant-design/icons';
import FreightBill from './FreightBill.jsx';
import OrderVerify from './OrderVerify.jsx';

/**
 * 对账中心：合并 快递对账 / 订单校验 两个「上传→比对→差异」页面为页签。
 * 账单核算（旧 billMonthly 口径）已迁移至「账务流水 → 对账核对」，本容器不再挂载。
 * 支持 ?tab=order / ?tab=freight 深链（旧地址迁移跳转用）。
 */
export default function ReconcileCenter() {
  const location = useLocation();
  const initialTab = new URLSearchParams(location.search || '').get('tab') === 'order' ? 'order' : 'freight';
  return (
    <Tabs
      defaultActiveKey={initialTab}
      className="reconcile-tabs"
      tabBarStyle={{ padding: '0 24px' }}
      items={[
        { key: 'freight', label: (<span><TruckOutlined /> 快递对账</span>), children: <FreightBill /> },
        { key: 'order', label: (<span><AuditOutlined /> 订单校验</span>), children: <OrderVerify /> },
      ]}
    />
  );
}
